/** Shared number formatting. Units carry 4dp, money 2dp. */

export const formatUnits = (value) =>
    Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 });

export const formatMoney = (value) =>
    Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** An instant as Colombo wall-clock time - the register's business clock (Rule 36(3)). '—' when there is none. */
export const formatInstant = (iso) =>
    iso ? new Date(iso).toLocaleString('en-GB', { timeZone: 'Asia/Colombo', dateStyle: 'medium', timeStyle: 'short' }) : '—';
